import { createApi } from '../axios'
import { baseURL } from '../config'

function responseHandle (res) {
  let msg = ''
  if (!res.data) {
    msg = res.status
    throw new Error(msg)
  } else if (res.data.ret !== 0) {
    msg = res.data.ret + ' ' + res.data.msg
    throw new Error(msg)
  }

  return res.data
} 

export default createApi(responseHandle, {
  getTickets(params) {
    return {
      url: '/api/v1/hlwmp/get_tickets',
      method: 'get',
      params: params,
      baseURL,
    }
  },
})